import type { CrmDealProductKind, CrmDealStage } from '@upme/contracts';

/** Порядок колонок на доске (слева направо). */
export const CRM_STAGE_ORDER: readonly CrmDealStage[] = [
  'new',
  'lead',
  'negotiation',
  'waiting',
  'won',
  'partner',
];

export const CRM_STAGE_LABEL_RU: Record<CrmDealStage, string> = {
  new: 'Новый контакт',
  lead: 'Потенциальный клиент',
  negotiation: 'Обсуждение',
  waiting: 'Ждём ответ',
  won: 'Клиент',
  partner: 'Партнёр',
};

export const CRM_PRODUCT_LABEL_RU: Record<CrmDealProductKind, string> = {
  pro: 'Pro',
  partner: 'Gold / партнёр',
  investor: 'Invest',
  event: 'Мероприятие',
  service: 'Услуга',
  other: 'Другое',
};
